import { KnmCollapse } from '../../KnmPackage/MainModule/components/KnmCollapse';
import { IGroupEventConditionsForm } from '../PassportGroupFormModule/interfaces/IGroupEventConditionsForm';
import { FieldBlock } from '../../UIPackage/FormModule/components/FieldBlock';
import { SelectInput } from '../../UIPackage/MainModule/components/SelectInput';

interface IPassportGroupDetailEventConditionsProps {
  condition: IGroupEventConditionsForm | undefined;
}

export const PassportGroupDetailEventConditions = ({ condition }: IPassportGroupDetailEventConditionsProps) => {
  if (!condition || !Object.values(condition).find(item => !!item)) {
    return null;
  }

  return (
    <KnmCollapse title="Действия, осуществляемые в рамках КНМ">
      <>
        {!!condition.eventTypes?.length && (
          <FieldBlock label="Действия" margin="bottom">
            <SelectInput value={condition.eventTypes} isMulti disabled />
          </FieldBlock>
        )}
      </>
    </KnmCollapse>
  );
};
